import styled from 'styled-components';

const FONT_SANS =
  "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

export const PickerWrap = styled.div`
  position: relative;
`;

export const TriggerBtn = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  background: ${({ theme: { colors = {} } }) =>
    colors.surfaceContainerHigh ?? '#1F2030'};
  border: 1px solid
    ${({ theme: { colors = {} } }) => colors.outlineVariant ?? '#464555'};
  border-radius: 999px;
  padding: 5px 10px 5px 6px;
  min-height: 36px;
  font: 500 13px/1.35 ${FONT_SANS};
  color: ${({ theme: { colors = {} } }) => colors.onSurface ?? '#E4E1ED'};
  outline: none;
  cursor: pointer;
  text-align: left;
  transition: border-color 120ms ease, background 120ms ease;
  gap: 4px;

  &:focus-visible,
  &[aria-expanded='true'] {
    border-color: ${({ theme: { colors = {} } }) =>
      colors.primary ?? '#C1C1FF'};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.55;
  }
`;

export const AvatarStack = styled.span`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;

  & > *:not(:first-child) {
    margin-left: -6px;
  }
`;

export const Placeholder = styled.span`
  color: ${({ theme: { colors = {} } }) =>
    colors.onSurfaceVariant ?? '#C7C4D7'};
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SelectedLabel = styled.span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 4px;
`;

export const Caret = styled.span`
  color: ${({ theme: { colors = {} } }) =>
    colors.onSurfaceVariant ?? '#C7C4D7'};
  font-size: 18px;
  margin-left: auto;
  flex-shrink: 0;
  transition: transform 140ms ease;

  ${TriggerBtn}[aria-expanded='true'] & {
    transform: rotate(180deg);
  }
`;

// Carries the React Flow `nowheel` class so wheel scrolling inside the
// dropdown list scrolls the list instead of zooming the surrounding
// canvas when the picker is rendered inside a React Flow node.
export const Dropdown = styled.div.attrs({ className: 'nowheel' })`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: ${({ theme: { colors = {} } }) =>
    colors.surfaceContainerHigh ?? '#1F2030'};
  border: 1px solid
    ${({ theme: { colors = {} } }) => colors.outlineVariant ?? '#464555'};
  border-radius: 16px;
  padding: 4px;
  max-height: 220px;
  overflow-y: auto;
  z-index: 30;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.45);
`;

export const PersonRow = styled.button<{ $selected?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  border: 0;
  border-radius: 12px;
  padding: 6px 10px;
  font: 500 13px/1.35 ${FONT_SANS};
  color: ${({ theme: { colors = {} } }) => colors.onSurface ?? '#E4E1ED'};
  background: ${({ $selected, theme: { colors = {} } }) =>
    $selected
      ? `color-mix(in oklch, ${colors.primary ?? '#C1C1FF'} 14%, transparent)`
      : 'transparent'};
  cursor: pointer;
  text-align: left;

  &:hover {
    background: ${({ theme: { colors = {} } }) =>
      `color-mix(in oklch, ${colors.primary ?? '#C1C1FF'} 10%, transparent)`};
  }
`;

export const PersonName = styled.span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CheckMark = styled.span`
  font-size: 16px;
  color: ${({ theme: { colors = {} } }) => colors.primary ?? '#C1C1FF'};
  flex-shrink: 0;
`;

export const Overflow = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme: { colors = {} } }) =>
    colors.onSurfaceVariant ?? '#C7C4D7'};
  flex-shrink: 0;
`;

export const EmptyRow = styled.div`
  padding: 6px 10px;
  font: 400 13px/1.35 ${FONT_SANS};
  color: ${({ theme: { colors = {} } }) =>
    colors.onSurfaceVariant ?? '#C7C4D7'};
`;
